import React from "react";
import { Draggable } from "@hello-pangea/dnd";
import styled from "styled-components";
import AssigneeButton from 'components/tasks/TasksViewer/AssigneeButton';
import { usePatchTaskMutation } from 'services/tasks/api';

const CardHeader = styled.div`
  font-weight: 500;
`;

const Author = styled.div`
  display: flex;
  align-items: center;
`;
const CardFooter = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const DragItem = styled.div`
  padding: 10px;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  background: white;
  margin: 0 0 8px 0;
  display: grid;
  grid-gap: 20px;
  flex-direction: column;
`;

interface ListItemProps {
  item: any;
  index: number;
}

const ListItem = ({
  item,
  index,
}: ListItemProps) => {
  const [patchTask] = usePatchTaskMutation();
  const task = item.task;

  return (
    <Draggable
      draggableId={item.id}
      index={index}
    >
      {
        (provided) => {
          return (
            <DragItem
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              style={{
                position: 'relative',
              }}
            >
              <CardHeader>{item.content}</CardHeader>
              <span>Content</span>
              <CardFooter>
                <Author>
                  {item.id}
                  <AssigneeButton
                    assigneeId={task?.assignee}
                    onChange={assignee => {
                      if (task?.id) {
                        patchTask({
                          id: task.id,
                          assignee,
                        });
                      }
                    }}
                    style={{
                      bottom: 10,
                      position: 'absolute',
                      right: 10,
                    }}
                  />
                </Author>
              </CardFooter>
            </DragItem>
          );
        }
      }
    </Draggable>
  );
};

export default ListItem;
